import Stack from '@mui/material/Stack';

import { styled } from '@/theme/styled';
import { getBorder } from '@/theme/utils';

const Container = styled(Stack)(({ theme }) => ({
  width: 300,
}));

const Section = styled(Stack)(({ theme }) => ({
  '&:not(:last-child)': {
    borderBottom: getBorder(theme.palette.border.default),
  },
  padding: theme.spacing(1),
}));

export { Container, Section };
